import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Popconfirm,
  notification,
  Drawer,
  Button,
  Timeline,
} from "antd";
import {
  OrderedListOutlined,
  RollbackOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import ProjectStepNoteListFilter from "../Filters/ProjectStepNoteListFilter";
import moment from "moment";
import ProjectStepNoteUpdateForm from "../Forms/ProjectStepNoteUpdateForm";

const ProjectStepNoteByProjectStepList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "PROJE ADIMI NOTLARI",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [totalProjectStepCount, setTotalProjectStepCount] = useState(0);
  const [firmName, setFirmName] = useState("");
  const [updateFormData, setUpdateFormData] = useState({});
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [projectStepId, setProjectStepId] = useState(null);
  const [addProjectStepNoteVisibility, setAddProjectStepNoteVisibility] =
    useState(false);
  const [isEditAllowed, setIsEditAllowed] = useState(true);

  useEffect(
    () => getTableData(),
    [props.match.params.firmId, tableDataQueryOptions]
  );

  useEffect(() => {
    RequestHandler.get(
      `/ProjectStep/GetById/${props.match.params.projectStepId}`
    ).then((response) => {
      setFirmName(response.name);
    });
    RequestHandler.get(`/User/GetTenantUserDetail`).then((response) => {
      if (response.success) {
        if (response.data.isAdmin === false) {
          setIsEditAllowed(false);
        }
      }
    });
  }, []);

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/ProjectStepNote/${props.match.params.projectStepId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response?.value,
        loading: false,
        total: response["@odata.count"],
      });

      if (conditions.length == 0) {
        setTotalProjectStepCount(response["@odata.count"]);
      }
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan Proje Adımı güncellenemez.",
    });
  };

  const openNotificationForNotAuthWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description:
        "Ekleyen Kullanıcısı olmadığınız Proje Adımı Notu'nu güncelleyemezsiniz.",
    });
  };
  const columns = [
    {
      title: "Proje Adımı",
      dataIndex: "projectStepName",
      key: "projectStepName",
    },
    {
      title: "Not",
      dataIndex: "note",
      key: "note",
      align: "left",
      render: (text) => {
        if (!text) return "";
        else
          return (
            <Tooltip title={text}>
              <span>
                {text.substring(0, 60).length < 60
                  ? text.substring(0, 60) + ""
                  : text.substring(0, 60) + "..."}
              </span>
            </Tooltip>
          );
      },
    },
    {
      title: "Eklenme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY HH:mm") : "-"),
    },
    {
      title: "Ekleyen Kullanıcı",
      dataIndex: "addUserName",
      key: "addUserName",
    },
    {
      title: "Son Güncellenme Tarihi",
      dataIndex: "updateDate",
      key: "updateDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY HH:mm") : "-"),
    },
    {
      title: "Son Güncelleyen Kullanıcı",
      dataIndex: "updateUserName",
      key: "updateUserName",
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        tableData.total >= 1 ? (
          <a onClick={() => handleOnClickUpdate(row)}>
            <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
          </a>
        ) : null,
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data, row) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(row)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const handleOnClickDelete = (row) => {
    if (row.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
      openNotificationForNotAuthWithIcon("warning");
      return;
    }

    RequestHandler.delete(`/ProjectStepNote/${row.id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };
  const handleOnClickUpdate = (record) => {
    if (record.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
      openNotificationForNotAuthWithIcon("warning");
      return;
    }

    RequestHandler.get(`/ProjectStepNote/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const onUpdateProjectStepSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
    setAddProjectStepNoteVisibility(false);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={18} lg={6} style={{ textAlign: "right" }}>
          <span style={{ marginRight: 50, fontSize: 16 }}>
            {" "}
            Toplam Proje Adımı Not Sayısı: {totalProjectStepCount}
          </span>
        </Col>
        <Col xs={24} md={6} lg={2} style={{ textAlign: "start", fontSize: 19 }}>
          <p style={{ fontWeight: "bold", color: "#2c3e50" }}>
            <span style={{ color: "#6f5196" }}>{firmName}</span>
          </p>
        </Col>
      </Row>
      <ProjectStepNoteListFilter
        firmId={props.match.params.firmId}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={false}
        style={{ marginTop: 12, marginBottom: 12 }}
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="updateProjectStepNoteDrawer"
        title="Proje Adımı Notu Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <ProjectStepNoteUpdateForm
          data={updateFormData}
          onSuccess={onUpdateProjectStepSuccess}
        />
      </Drawer>
    </>
  );
};

export default ProjectStepNoteByProjectStepList;
